// introduced because of web components
export enum LinkDesign {
  Default = 'Default',
  Subtle = 'Subtle',
  Emphasized = 'Emphasized'
}
